import { GetCharacterizationUseCase } from '@/application/characterization/getCharacterizationUseCase';
import { characterizationApiRepository } from '@/infra/repositories/characterizationApi.repository';

// variables privadas del modulo
let _getCharacterizationUseCase: GetCharacterizationUseCase | null = null;

/**
 * Función que inyecta una instancia de GetCharacterizationUseCase
 * Proporciona acceso al caso de uso para obtener datos de caracterización
 */
export const getCharacterizationUseCase = () => {
  if (!_getCharacterizationUseCase)
    _getCharacterizationUseCase = new GetCharacterizationUseCase(
      characterizationApiRepository,
    );

  return _getCharacterizationUseCase;
};

export const resetCharacterizationContainer = (): void => {
  _getCharacterizationUseCase = null;
};
